export const dateContent = (date: string) => {
  let numbers = ['2', '3', '4'];
  const number = numbers.find(number => date.includes(number));

  switch (date) {
    case 'rok':
      return 'roku';
    case `${number} lata`:
      return `${number} lat`;
    case `miesiąc`:
      return `miesiąca`;
    case `${number} miesiące`:
      return `${number} miesięcy`;
    case `1 dzień`:
      return `1 dnia`;
    case `godzina`:
      return `godziny`;
    case `${number} godziny`:
      return `${number} godzin`;
    default:
      return date;
  }
};
